import { SIAnnualPremiumMembership } from '../ReferralProgram.ts';
import * as Item from './StoreItemList.ts';
export class StoreItemController {
    static getItemsInCategory(category, onlyIncludeActiveItems = true) {
        const itemsInCategory = [];
        for (const item of StoreItemController.itemList){
            if (onlyIncludeActiveItems && !item.activeInStore) continue;
            if (item.category != category) continue;
            itemsInCategory.push(item);
        }
        return itemsInCategory;
    }
    static getItemDetail(category, type) {
        return this.getItemDetailFromArray(category, type, StoreItemController.itemList);
    }
    static getItemDetailForReferralProgram(category, type) {
        return this.getItemDetailFromArray(category, type, [
            ...StoreItemController.itemList,
            new SIAnnualPremiumMembership()
        ]);
    }
    static getItemDetailFromArray(category, type, itemArray) {
        for (const item of itemArray){
            if (item.category != category) continue;
            if (item.type != type) continue;
            return item;
        }
        return undefined;
    }
}
StoreItemController.itemList = [
    new Item.SISettlerPack(),
    new Item.SIColonistPack(),
    new Item.SIFounderPack(),
    new Item.SIExpansionCitiesAndKnightsSeafarers4P(),
    new Item.SIExpansionCitiesAndKnightsSeafarers56P(),
    new Item.SIExpansionCitiesAndKnights4P(),
    new Item.SIExpansionCitiesAndKnights56P(),
    new Item.SIExpansionSeafarers4P(),
    new Item.SIExpansionSeafarers56P(),
    new Item.SIExpansionClassic56P(),
    new Item.SIExpansionClassic78P(),
    new Item.SIExpansionColonistRush4P(),
    new Item.SIExpansionTradersAndBarbarians(),
    new Item.SIExpansionExplorersAndPirates(),
    new Item.SIMapGoldRush(),
    new Item.SIMapVolcano(),
    new Item.SIMapBlackForest(),
    new Item.SIMapShuffleBoard(),
    new Item.SIMapRandomBase(),
    new Item.SIMapEarth(),
    new Item.SIMapUSA(),
    new Item.SIMapUK(),
    new Item.SIMapDiamond(),
    new Item.SIMapGear(),
    new Item.SIMapLakes(),
    new Item.SIMapPond(),
    new Item.SIMapTwirl(),
    // new Item.SIIconMedalGold(), new Item.SIIconMedalSilver(), new Item.SIIconMedalBronze(),
    new Item.SIIconMummy(),
    new Item.SIIconRobberCupid(),
    new Item.SIIconRobberLunar(),
    new Item.SIIconRobberSanta(),
    new Item.SIIconElephant(),
    new Item.SIIconSombrero(),
    new Item.SIIconFarmer(),
    new Item.SIIconAvocado(),
    new Item.SIIconCrown(),
    new Item.SIIconCactus(),
    new Item.SIIconGifter(),
    new Item.SIIconSwords(),
    new Item.SIIconWorker(),
    new Item.SIIconHelmet(),
    new Item.SIIconScarf(),
    new Item.SIIconSnorkel(),
    new Item.SIIconTie(),
    new Item.SIIconPirateShip(),
    new Item.SIIconChristmasHat(),
    new Item.SIIconPlayer(),
    new Item.SIIconSettlerHat(),
    new Item.SIIconColonistHat(),
    new Item.SIIconFounderHat(),
    new Item.SIColorBronze(),
    new Item.SIColorSilver(),
    new Item.SIColorGold(),
    new Item.SIColorBlack(),
    new Item.SIColorWhite(),
    new Item.SIColorPurple(),
    new Item.SIColorMysticBlue(),
    new Item.SIColorPink(),
    new Item.SIUsernameChange()
];
